export default __webpack_public_path__ + "static/reseller-9669f108b93f1c23c1f6c8fcf41f12fa.png";